import {GET_ROBOTS_SUCCESS} from "../../../reducers/editErrorReducer";


export const getRobotsSuccess= (robots) =>{
    return {
        type: GET_ROBOTS_SUCCESS,
        payload: {robots}
    }
}